import React from "react";
import FilterList from "../../../components/user/stock/stockFilterList";
import Layout from "../../../components/layouts/verticalLayout";

const StockListPage = (props) => {
  return <Layout body={<FilterList />} />;
};

StockListPage.propTypes = {};

export default StockListPage;
